import { jsxs as C, jsx as e } from "react/jsx-runtime";
import { EditorMenuContent as B } from "../../shared/editor-menu-content/EditorMenuContent.component.js";
import { LabeledSelect as G } from "../../shared/labeled-select/LabeledSelect.component.js";
import { useReducer as q, useState as W, useEffect as z, useCallback as m, useMemo as w } from "react";
import { F as I } from "../../index-gVtEopq1.js";
import { StepFormGenericType as J } from "./StepFormGenericType.component.js";
import { InputLabelWrapper as H } from "../../shared/input-label-wrapper/InputLabelWrapper.component.js";
import { Divider as K } from "../../shared/divider/Divider.component.js";
import { stepFormReducer as Y } from "./step-form-reducer.js";
import { StepHandlerFactory as h } from "./step-params-handlers.js";
import { StepParamsFields as V } from "./StepParamsFields.component.js";
import { useActionTypeOptions as Q } from "./use-action-type-options.js";
import { LabeledTextInput as X } from "../../shared/labeled-text-input/LabeledTextInput.component.js";
import { InputSizeEnum as Z, InputThemeEnum as $ } from "../../shared/input/types.js";
import { FieldReadonly as S } from "../../shared/field-readonly/FieldReadonly.component.js";
import { S as L } from "../../StepParamInput.component-BhWeSFHZ.js";
import { useBoolean as nn } from "../../shared/utils.js";
import { Button as on } from "../../shared/button/Button.component.js";
import { S as an } from "../../code-icon-_TZmqcZi.js";
import { ButtonThemeEnum as rn, ButtonSizeEnum as tn } from "../../shared/button/types.js";
import { LabeledJsonInput as N } from "../../shared/labeled-json-input/LabeledJsonInput.component.js";
import { GenericTypeStepMutationHandler as en } from "./step-params-generic-type-mutation-handler.js";
import '../../assets/StepForm.css';const sn = "_form_8drdf_2", ln = "_container_8drdf_9", cn = "_divider_8drdf_22", un = "_leftColumn_8drdf_26", mn = "_rightColumn_8drdf_38", pn = "_labelWrapper_8drdf_48", gn = "_label_8drdf_48", Cn = "_stepParamsInput_8drdf_66", fn = "_devModeContainer_8drdf_86", dn = "_inputContainer_8drdf_93", _n = "_input_8drdf_93", yn = "_devModeButton_8drdf_103", Tn = "_icon_8drdf_111", s = {
  form: sn,
  container: ln,
  divider: cn,
  leftColumn: un,
  rightColumn: mn,
  labelWrapper: pn,
  label: gn,
  stepParamsInput: Cn,
  devModeContainer: fn,
  inputContainer: dn,
  input: _n,
  devModeButton: yn,
  icon: Tn
}, b = [
  "json-logic",
  "js"
], hn = {
  fieldId: "skip",
  fieldName: "skip",
  label: "Skip condition",
  type: I.String,
  required: !1,
  originalPath: ["skip"]
}, Ln = {
  fieldId: "continue",
  fieldName: "continue",
  label: "Continue condition",
  type: I.String,
  required: !1,
  originalPath: ["continue"]
}, Nn = ({
  state: i,
  schema: c
}) => /* @__PURE__ */ C("div", { className: s.devModeContainer, children: [
  /* @__PURE__ */ e(
    N,
    {
      labelText: "Step definition",
      id: "stepDefinition",
      error: null,
      readOnly: !0,
      initialContent: i,
      className: s.input,
      containerClassName: s.inputContainer
    }
  ),
  c && /* @__PURE__ */ e(
    N,
    {
      labelText: "Step input schema",
      id: "stepInputSchema",
      error: null,
      readOnly: !0,
      initialContent: c,
      className: s.input,
      containerClassName: s.inputContainer
    }
  )
] }), Hn = ({
  copies: i,
  onClose: c,
  apiDeclaration: p,
  declaration: v,
  onAddStep: _,
  editedStep: o,
  onEditStep: y
}) => {
  const [f, , , E] = nn(!1), [n, l] = q(Y, {
    actionType: o == null ? void 0 : o.type,
    params: (o == null ? void 0 : o.params) ?? {},
    skipCondition: (o == null ? void 0 : o.skipCondition) ?? {},
    continueCondition: (o == null ? void 0 : o.continueCondition) ?? {},
    description: (o == null ? void 0 : o.description) ?? "",
    paramsConfig: (o == null ? void 0 : o.paramsConfig) ?? {},
    continueConditionLanguage: (o == null ? void 0 : o.continueConditionLanguage) ?? "json-logic",
    skipConditionLanguage: (o == null ? void 0 : o.skipConditionLanguage) ?? "json-logic"
  }), { actionTypeOptions: O, selectedActionTypeOption: g } = Q(
    i,
    n
  ), [r, k] = W(
    o != null && o.type ? h.create(o == null ? void 0 : o.type, p) : null
  );
  z(() => {
    if (r && r instanceof en) {
      const {
        ["Object.fromEntries"]: t,
        object: a,
        ...u
      } = n.params.fields;
      if (!t && !a)
        return;
      const d = {
        ...t ? Object.fromEntries(t) : {},
        ...a ? Object.fromEntries(a) : {},
        ...u
      };
      l({
        type: "PARAMS_UPDATED",
        payload: { ...n.params, fields: d }
      });
    }
  }, [n, r]);
  const P = m(() => {
    if (!n.actionType) {
      l({
        type: "ACTION_TYPE_ERROR",
        payload: i.actionTypeRequiredError
      });
      return;
    }
    if (!r)
      return;
    const t = r.validate(n.params);
    if (t !== !0) {
      l({
        type: "PARAMS_VALIDATION_ERROR",
        payload: Object.fromEntries(
          t.map((a) => [
            a.fieldName,
            i.fieldRequiredError
          ])
        )
      });
      return;
    }
    if (o) {
      y({
        ...o,
        description: n.description,
        type: n.actionType,
        params: n.params,
        skipCondition: n.skipCondition,
        continueCondition: n.continueCondition,
        paramsConfig: n.paramsConfig,
        skipConditionLanguage: n.skipConditionLanguage,
        continueConditionLanguage: n.continueConditionLanguage
      }), c();
      return;
    }
    _({
      id: "",
      description: n.description,
      type: n.actionType,
      params: n.params,
      nextStep: null,
      skipCondition: n.skipCondition,
      continueCondition: n.continueCondition,
      paramsConfig: n.paramsConfig,
      skipConditionLanguage: n.skipConditionLanguage,
      continueConditionLanguage: n.continueConditionLanguage
    }), c();
  }, [
    i.actionTypeRequiredError,
    i.fieldRequiredError,
    o,
    _,
    c,
    y,
    n.actionType,
    n.continueCondition,
    n.continueConditionLanguage,
    n.description,
    n.params,
    n.paramsConfig,
    n.skipCondition,
    n.skipConditionLanguage,
    r
  ]), D = m(
    (t) => {
      var T;
      const a = t == null ? void 0 : t.value;
      if (!a)
        return;
      const u = h.create(
        a,
        p
      ), d = u.getInitialState(
        n.params,
        r ?? void 0
      ) ?? {}, U = ((T = u.getInitialParamsConfig) == null ? void 0 : T.call(u)) ?? {};
      k(u), l({
        type: "ACTION_TYPE_SELECTED",
        payload: { value: a, initialParams: d, initialParamsConfig: U }
      });
    },
    [p, n, r]
  ), A = m(
    (t) => {
      l({ type: "DESCRIPTION_UPDATED", payload: t.target.value });
    },
    []
  ), F = m(
    (t, a) => {
      l({ type: "SKIP_CONDITION_UPDATED", payload: a });
    },
    []
  ), M = m(
    (t, a) => {
      l({
        type: "CONTINUE_CONDITION_UPDATED",
        payload: a
      });
    },
    []
  ), R = m(
    (t, a) => {
      l({
        type: "SKIP_CONDITION_LANGUAGE_UPDATED",
        payload: a
      });
    },
    []
  ), j = m(
    (t, a) => {
      l({
        type: "CONTINUE_CONDITION_LANGUAGE_UPDATED",
        payload: a
      });
    },
    []
  ), x = w(() => ({
    ...i,
    submit: o ? i.update : i.add
  }), [i, o]);
  return /* @__PURE__ */ C(
    B,
    {
      onSave: P,
      copies: x,
      close: c,
      className: s.form,
      isDisabled: f,
      children: [
        f ? /* @__PURE__ */ e(Nn, { state: n, schema: r == null ? void 0 : r.schema }) : /* @__PURE__ */ C("div", { className: s.container, children: [
          /* @__PURE__ */ C("div", { className: s.leftColumn, children: [
            o != null && o.type ? /* @__PURE__ */ e(
              S,
              {
                id: "flowActionType",
                label: i.actionTypeInputLabel,
                text: g == null ? void 0 : g.label
              }
            ) : /* @__PURE__ */ e(
              G,
              {
                labelText: i.actionTypeInputLabel,
                placeholder: i.actionTypeInputPlaceholder,
                options: O,
                id: "flowActionType",
                error: n.actionTypeError ?? null,
                onChange: D,
                value: g
              }
            ),
            r && "isGenericTypeStepHandler" in r && /* @__PURE__ */ e(
              J,
              {
                state: n,
                dispatch: l,
                apiDeclaration: p,
                declaration: v,
                copies: i,
                stepHandler: r
              }
            ),
            /* @__PURE__ */ e(
              X,
              {
                id: "flowDescription",
                labelText: i.descriptionLabel,
                inputTheme: $.secondary,
                inputSize: Z.md,
                error: null,
                placeholder: i.descriptionPlaceholder,
                value: n.description,
                onChange: A,
                maxLength: 64
              }
            ),
            /* @__PURE__ */ e(
              L,
              {
                error: "",
                onChange: F,
                onLogicLanguageChange: R,
                field: hn,
                value: typeof n.skipCondition == "string" ? n.skipCondition : JSON.stringify(n.skipCondition),
                copies: i,
                logicLanguageOptions: b,
                logicLanguage: n.skipConditionLanguage
              }
            ),
            /* @__PURE__ */ e(
              L,
              {
                error: "",
                onChange: M,
                onLogicLanguageChange: j,
                field: Ln,
                value: typeof n.continueCondition == "string" ? n.continueCondition : JSON.stringify(n.continueCondition),
                copies: i,
                logicLanguageOptions: b,
                logicLanguage: n.continueConditionLanguage
              }
            )
          ] }),
          /* @__PURE__ */ e(K, { className: s.divider }),
          /* @__PURE__ */ e("div", { className: s.rightColumn, children: /* @__PURE__ */ e(
            H,
            {
              labelText: i.input,
              id: "stepParams",
              containerClassName: s.labelWrapper,
              className: s.label,
              children: /* @__PURE__ */ e("div", { className: s.stepParamsInput, children: r && /* @__PURE__ */ e(
                V,
                {
                  stepHandler: r,
                  state: n,
                  dispatch: l,
                  copies: i
                },
                n.actionType
              ) })
            }
          ) })
        ] }),
        /* @__PURE__ */ e(
          on,
          {
            className: s.devModeButton,
            onClick: E,
            size: tn.sm,
            theme: rn.naked,
            forceActive: f,
            type: "button",
            children: /* @__PURE__ */ e(an, { className: s.icon })
          }
        )
      ]
    }
  );
};
export {
  Hn as StepForm,
  Nn as StepFormDev
};
